export default __webpack_public_path__ + "static/dark-mode-cat-e10947901422caecb2a045520f4c06d6.png";